export default "__VITE_ASSET__328068e9__"